"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateMealKitVariants = exports.buildPatientMealSelectionInputPayloadFromFlat = exports.filterDishes = exports.MenuOptionFilterType = exports.flattenDishes = exports.isDeliveryDelayed = exports.getShipmentCurrentStep = exports.shipmentStatusSteps = exports.getPriorityShipmentStatus = exports.joinMealTypes = exports.getSectionTypeLabel = exports.getFromDateForDeliveriesQuery = exports.getConcatWeekdaysOnDiet = exports.sortWeekDays = exports.groupMenuOptionsByMealOptionType = exports.mealOptionTypeLabels = exports.mealOptionTypeKeyMap = exports.groupDishes = exports.getAllMenuOptionSelections = exports.getAllMenuOptionSelectionsTags = exports.addToList = exports.isFull = exports.calculateAmountToSelect = exports.getQuantitySelected = exports.isQuantityExceeded = exports.getMealPlanOptionCategoryLabel = exports.getMealTypeTagLabelByValue = void 0;
var date_fns_1 = require("date-fns");
var lodash_1 = require("lodash");
var graphql_api_admin_1 = require("@fdha/graphql-api-admin");
var utils_1 = require("../../internal/utils");
var types_1 = require("../../types");
var date_1 = require("../date/date");
/**
 * Returns i18n object for meal type tag names
 * @param systemType - whether the system is mobile or web
 * @returns Record mapping MealOptionType to I18n objects
 */
var getMealTypeTagLabelByValue = function (systemType) {
    var _a;
    var i18nFirstSeparator = (0, utils_1.getI18nFirstSeparator)(systemType);
    return _a = {},
        _a[graphql_api_admin_1.MealOptionType.MealKit] = {
            key: "meals".concat(i18nFirstSeparator, "chooseMeals.subheader.mealKit"),
            fallback: 'Meal Kit',
        },
        _a[graphql_api_admin_1.MealOptionType.Dish] = {
            key: "meals".concat(i18nFirstSeparator, "chooseMeals.subheader.prepared"),
            fallback: 'Prepared',
        },
        _a;
};
exports.getMealTypeTagLabelByValue = getMealTypeTagLabelByValue;
/**
 * Returns i18n object for meal plan option category name
 * @param systemType - whether the system is mobile or web
 * @returns I18n object for the category name
 */
var getMealPlanOptionCategoryLabel = function (systemType) {
    var i18nFirstSeparator = (0, utils_1.getI18nFirstSeparator)(systemType);
    return {
        key: "meals".concat(i18nFirstSeparator, "chooseMeals.filters.categories.mealPlanOption"),
        fallback: 'Meal plan option',
    };
};
exports.getMealPlanOptionCategoryLabel = getMealPlanOptionCategoryLabel;
var shipmentStatusPriorityOrder = [
    types_1.DeliveryShipmentStatus.Transit,
    types_1.DeliveryShipmentStatus.BeingPrepared,
    types_1.DeliveryShipmentStatus.Returned,
    types_1.DeliveryShipmentStatus.Failure,
    types_1.DeliveryShipmentStatus.Unknown,
    types_1.DeliveryShipmentStatus.Delivered,
];
/**
 * Determines if the total quantity of selected dishes exceeds the specified limit.
 *
 * @param menu - Array of menu option selections.
 * @param amount - Maximum allowed quantity of selected dishes.
 * @returns `true` if the total quantity exceeds the specified amount, otherwise `false`.
 */
var isQuantityExceeded = function (menu, amount) {
    var quantity = (0, exports.getQuantitySelected)(menu);
    return quantity > amount;
};
exports.isQuantityExceeded = isQuantityExceeded;
/**
 * Calculates the total quantity of selected dishes from a list of menu options.
 *
 * @param menu - Array of menu option selections.
 * @returns The total quantity of selected dishes.
 */
var getQuantitySelected = function (menu) {
    return menu.reduce(function (actual, val) {
        return actual + val.quantity;
    }, 0);
};
exports.getQuantitySelected = getQuantitySelected;
/**
 * Calculates the amount of selections that the patient needs to order.
 * Checking if the total quantity of selected dishes exceeds the specified limit.
 *
 * @param values - Array of menu option selections.
 * @param defaultValue - Default amount of dishes to be selected.
 * @returns The total quantity of dishes the patient needs to select.
 */
var calculateAmountToSelect = function (values, defaultValue) {
    return (0, exports.isQuantityExceeded)(values, defaultValue)
        ? (0, exports.getQuantitySelected)(values)
        : defaultValue;
};
exports.calculateAmountToSelect = calculateAmountToSelect;
/**
 * Checks if the total quantity of selected dishes equals the specified total.
 *
 * @param menu - Array of menu option selections.
 * @param total - Total quantity to be checked against.
 * @returns `true` if the total quantity equals the specified total, otherwise `false`.
 */
var isFull = function (menu, total) {
    return (0, exports.getQuantitySelected)(menu) === total;
};
exports.isFull = isFull;
/**
 * Adds menu option selections to the list of dishes based on meal type.
 *
 * @param mealType - Type of the meal.
 * @param dishes - Array of menu option selections to be updated.
 * @param menu - Array of menu options to be added.
 */
var addToList = function (mealType, dishes, menu) {
    menu.forEach(function (item) {
        var index = dishes.findIndex(function (dish) { return dish.dishId === item.dishId; });
        if (index === -1) {
            dishes.push(__assign(__assign({}, item), { mealType: [mealType] }));
        }
        else {
            var oldDish = dishes[index];
            if (!oldDish) {
                return;
            }
            if (!oldDish.mealType) {
                throw new Error("Meal type is missing for dish ".concat(oldDish.dishId));
            }
            dishes[index] = __assign(__assign({}, oldDish), { quantity: oldDish.quantity + item.quantity, mealType: __spreadArray(__spreadArray([], oldDish.mealType, true), [mealType], false) });
        }
    });
};
exports.addToList = addToList;
/**
 * Returns all tags from the given menu option selections.
 * @param menuOptionSelections - Menu option selections to get tags from.
 * @returns All distinct tags from the given menu option selections sorted by name asc.
 */
var getAllMenuOptionSelectionsTags = function (menuOptionSelections) {
    var tags = menuOptionSelections.flatMap(function (selection) { var _a, _b; return (_b = (_a = selection.tagsByCategory) === null || _a === void 0 ? void 0 : _a.flatMap(function (tag) { return tag.tags; })) !== null && _b !== void 0 ? _b : []; });
    return (0, lodash_1.sortBy)((0, lodash_1.uniqBy)(tags, 'id'), 'name');
};
exports.getAllMenuOptionSelectionsTags = getAllMenuOptionSelectionsTags;
/**
 * Gets all menu option selections of entree dishes and snacks.
 * @param menuOptions - Menu options.
 * @returns all menu option selections of entree dishes and snacks.
 */
var getAllMenuOptionSelections = function (menuOptions) {
    return menuOptions.entreeDishes.concat(menuOptions.snacks);
};
exports.getAllMenuOptionSelections = getAllMenuOptionSelections;
/**
 * Groups dishes by meal type from the given menu selections.
 *
 * @param menuOptionSelection - Menu selections to be grouped.
 * @returns Grouped menu options by entree dishes and snacks or undefined if menu selections are empty.
 */
var groupDishes = function (menuOptionSelection) {
    if (!menuOptionSelection) {
        return;
    }
    var entreeDishes = [];
    var snacks = [];
    Object.entries(menuOptionSelection).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (!Array.isArray(value)) {
            return;
        }
        var mealTypeKey = key;
        if ([graphql_api_admin_1.MealType.Breakfast, graphql_api_admin_1.MealType.Lunch, graphql_api_admin_1.MealType.Dinner].includes(mealTypeKey)) {
            (0, exports.addToList)(mealTypeKey, entreeDishes, value);
        }
        else {
            (0, exports.addToList)(mealTypeKey, snacks, value);
        }
    });
    var options = {
        entreeDishes: entreeDishes.sort(function (a, b) { return a.name.localeCompare(b.name); }),
        snacks: snacks.sort(function (a, b) { return a.name.localeCompare(b.name); }),
    };
    return options;
};
exports.groupDishes = groupDishes;
/**
 * Groups dishes by meal type and mealOptionType (with sub-sections),
 * and for meal kits, groups by both dishId and mealkitVariantId.
 *
 * @param menuOptionSelection - Menu selections to be grouped.
 * @returns Grouped menu options by entree and snack sub-sections.
 */
exports.mealOptionTypeKeyMap = (_a = {},
    _a[graphql_api_admin_1.MealOptionType.Dish] = 'dish',
    _a[graphql_api_admin_1.MealOptionType.MealKit] = 'mealKit',
    _a);
exports.mealOptionTypeLabels = {
    dish: 'Prepared meal',
    mealKit: 'Meal kit',
};
/**
 * Resolves the sub-section key for a menu option type.
 */
var getMenuOptionSubSectionKey = function (mealOptionType) {
    if (!mealOptionType) {
        return graphql_api_admin_1.MealOptionType.Dish;
    }
    return exports.mealOptionTypeKeyMap[mealOptionType] || mealOptionType;
};
/**
 * Finds the index of a menu option (dish or meal kit) in the given array.
 */
var findMenuOptionIndex = function (arr, item, isMealKit) {
    if (!isMealKit) {
        return arr.findIndex(function (dish) { return dish.dishId === item.dishId; });
    }
    return arr.findIndex(function (dish) {
        return dish.dishId === item.dishId &&
            dish.mealkitVariantId === item.mealkitVariantId;
    });
};
/**
 * Adds or updates a menu option selection in the subSection, grouped by menu option type.
 * For meal kits, groups by both dishId and mealkitVariantId; otherwise, by dishId only.
 */
var addDishInMealOptionTypeGroup = function (subSection, item, mealType) {
    var _a;
    var key = getMenuOptionSubSectionKey((_a = item.mealOptionType) !== null && _a !== void 0 ? _a : '');
    if (!subSection[key]) {
        subSection[key] = [];
    }
    var isMealKit = item.mealOptionType === graphql_api_admin_1.MealOptionType.MealKit;
    var index = findMenuOptionIndex(subSection[key], item, isMealKit);
    if (index === -1) {
        // Insert new dish
        subSection[key].push(__assign(__assign({}, item), { mealType: [mealType] }));
        return;
    }
    // Update existing dish
    var oldDish = subSection[key][index];
    if (!oldDish.mealType) {
        throw new Error("Meal type is missing for ".concat(isMealKit ? 'meal kit' : 'dish', " ").concat(oldDish.dishId));
    }
    subSection[key][index] = __assign(__assign({}, oldDish), { quantity: oldDish.quantity + item.quantity, mealType: __spreadArray(__spreadArray([], oldDish.mealType, true), [mealType], false) });
};
var groupMenuOptionsByMealOptionType = function (menuOptionSelection) {
    var _a;
    if (!menuOptionSelection) {
        return;
    }
    var entreeDishes = (_a = {},
        _a[graphql_api_admin_1.MealOptionType.Dish] = [],
        _a[graphql_api_admin_1.MealOptionType.MealKit] = [],
        _a);
    var snacks = {};
    // Group the menu options by meal type
    Object.entries(menuOptionSelection).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (!Array.isArray(value)) {
            return;
        }
        var mealTypeKey = key;
        var isEntree = [
            graphql_api_admin_1.MealType.Breakfast,
            graphql_api_admin_1.MealType.Lunch,
            graphql_api_admin_1.MealType.Dinner,
        ].includes(mealTypeKey);
        if (isEntree) {
            value.forEach(function (item) {
                return addDishInMealOptionTypeGroup(entreeDishes, item, mealTypeKey);
            });
        }
        else {
            value.forEach(function (item) {
                return addDishInMealOptionTypeGroup(snacks, item, mealTypeKey);
            });
        }
    });
    // Sort the entree dishes and snacks by name
    Object.values(entreeDishes).forEach(function (arr) {
        return arr.sort(function (a, b) { return a.name.localeCompare(b.name); });
    });
    Object.values(snacks).forEach(function (arr) {
        return arr.sort(function (a, b) { return a.name.localeCompare(b.name); });
    });
    return { entreeDishes: entreeDishes, snacks: snacks };
};
exports.groupMenuOptionsByMealOptionType = groupMenuOptionsByMealOptionType;
/**
 * Sorts the array of weekdays from sun to sat.
 *
 * @param weekdays - Array of weekdays to be sorted.
 * @returns Sorted array of weekdays.
 */
var sortWeekDays = function (weekdays) {
    var data = (0, lodash_1.uniq)(weekdays);
    var weekdaysOrder = [
        graphql_api_admin_1.WeekDay.Sun,
        graphql_api_admin_1.WeekDay.Mon,
        graphql_api_admin_1.WeekDay.Tue,
        graphql_api_admin_1.WeekDay.Wed,
        graphql_api_admin_1.WeekDay.Thu,
        graphql_api_admin_1.WeekDay.Fri,
        graphql_api_admin_1.WeekDay.Sat,
    ];
    return (0, lodash_1.orderBy)(data, function (day) { return weekdaysOrder.indexOf(day); });
};
exports.sortWeekDays = sortWeekDays;
/**
 * Concatenates the weekdays on diet from multiple user delivery menus.
 *
 * @param userDeliveryMenus - Array of user delivery menus.
 * @returns Concatenated and sorted (sun to sat) array of weekdays on diet.
 */
var getConcatWeekdaysOnDiet = function (userDeliveryMenus) {
    var _a, _b, _c, _d;
    var firstUserDeliveryWeekdaysOnDiet = (_b = (_a = userDeliveryMenus[0]) === null || _a === void 0 ? void 0 : _a.weekdaysOnDiet) !== null && _b !== void 0 ? _b : [];
    var secondUserDeliveryWeekdaysOnDiet = (_d = (_c = userDeliveryMenus[1]) === null || _c === void 0 ? void 0 : _c.weekdaysOnDiet) !== null && _d !== void 0 ? _d : [];
    var weekdaysOnDiet = firstUserDeliveryWeekdaysOnDiet.concat(secondUserDeliveryWeekdaysOnDiet);
    weekdaysOnDiet = (0, exports.sortWeekDays)(weekdaysOnDiet);
    return weekdaysOnDiet;
};
exports.getConcatWeekdaysOnDiet = getConcatWeekdaysOnDiet;
/**
 * Returns the from date to be used in deliveries query based on an offset
 * @param offset number of days to subtract from today
 * @returns date in format yyyy-MM-dd
 */
var getFromDateForDeliveriesQuery = function (offset) {
    var today = (0, date_1.convertDateToLocalUtc)((0, date_fns_1.startOfToday)());
    return (0, date_fns_1.format)((0, date_fns_1.subDays)(today, offset), 'yyyy-MM-dd');
};
exports.getFromDateForDeliveriesQuery = getFromDateForDeliveriesQuery;
/**
 * Returns the label for the given section type, optionally considering if there are sides.
 *
 * @param type - Type of the section (entreeDishes or snacks).
 * @param hasSides - Whether the section has sides.
 * @returns Label for the section type.
 */
var getSectionTypeLabel = function (type, hasSides) {
    if (type === 'snacks') {
        if (hasSides) {
            return 'Snacks/Sides';
        }
        return 'Snacks';
    }
    return 'Entree dishes';
};
exports.getSectionTypeLabel = getSectionTypeLabel;
/**
 * Joins and capitalizes meal types, using a translation function for each meal type.
 *
 * @param types - Array of meal types to be joined and capitalized.
 * @param translate - Function to translate meal type keys to their respective values.
 * @returns A string of joined and capitalized meal types.
 */
var joinMealTypes = function (types, translate) {
    return types
        .map(function (type) { return (0, lodash_1.capitalize)(translate("meals.mealType.".concat(type), type)); })
        .join(', ');
};
exports.joinMealTypes = joinMealTypes;
/**
 * Gets the most priority shipment status from the given list of shipment statuses.
 *
 * @param status - Array of shipment statuses.
 * @returns Most priority shipment status.
 */
var getPriorityShipmentStatus = function (status) {
    var mostPriority = status.sort(function (a, b) {
        return (shipmentStatusPriorityOrder.indexOf(a) -
            shipmentStatusPriorityOrder.indexOf(b));
    })[0];
    return mostPriority;
};
exports.getPriorityShipmentStatus = getPriorityShipmentStatus;
exports.shipmentStatusSteps = [
    types_1.DeliveryShipmentStatus.BeingPrepared,
    types_1.DeliveryShipmentStatus.Transit,
    types_1.DeliveryShipmentStatus.Delivered,
];
/**
 * Gets the current step of shipment statuses
 * @param status current shipment status
 * @returns current step of shipment statuses
 */
var getShipmentCurrentStep = function (status) {
    return exports.shipmentStatusSteps.indexOf(status) + 1;
};
exports.getShipmentCurrentStep = getShipmentCurrentStep;
/**
 * Verifies if the shipment labels are delayed, based on the highest ETA and the expected delivery date, excluding delivered shipments
 * @param deliveryDate expected delivery date
 * @param shipmentLabels list of shipment labels of the delivery order
 * @returns boolean indicating if the delivery is delayed
 */
var isDeliveryDelayed = function (deliveryDate, shipmentLabels) {
    if (!shipmentLabels) {
        return false;
    }
    var filteredLabels = shipmentLabels.filter(function (label) { return label.trackingStatus !== graphql_api_admin_1.TrackingStatus.Delivered; });
    var highestEta = filteredLabels.reduce(function (maxEta, label) {
        var currentEta = new Date(label.eta);
        return currentEta > maxEta ? currentEta : maxEta;
    }, new Date(0));
    return (0, date_fns_1.differenceInDays)(deliveryDate, highestEta) < 0;
};
exports.isDeliveryDelayed = isDeliveryDelayed;
/**
 * Flattens a nested structure of dishes into a single array
 */
var flattenDishes = function (dishes) { return Object.values(dishes).flat(); };
exports.flattenDishes = flattenDishes;
/**
 * Enum for filter types used in filterDishes function
 */
var MenuOptionFilterType;
(function (MenuOptionFilterType) {
    MenuOptionFilterType["QUANTITY_GT_0"] = "quantity_gt_0";
    MenuOptionFilterType["ALL"] = "all";
})(MenuOptionFilterType || (exports.MenuOptionFilterType = MenuOptionFilterType = {}));
/**
 * Filters dishes based on a filter type or custom predicate
 * @param items Record of menu options by meal option type
 * @param filterType Filter type to use (MenuOptionFilterType.QUANTITY_GT_0 for dishes with quantity > 0, MenuOptionFilterType.ALL for no filtering) or custom filter function
 * @returns Filtered record of menu options
 */
var filterDishes = function (items, filterType) {
    if (filterType === void 0) { filterType = MenuOptionFilterType.ALL; }
    // Determine the predicate function to use
    var predicate;
    if (typeof filterType === 'function') {
        predicate = filterType;
    }
    else if (filterType === MenuOptionFilterType.QUANTITY_GT_0) {
        predicate = function (dish) { return dish.quantity > 0; };
    }
    else {
        // Default is FilterType.ALL
        predicate = function () { return true; };
    }
    return Object.fromEntries(Object.entries(items).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key, value.filter(predicate)];
    }));
};
exports.filterDishes = filterDishes;
/**
 * Alternative version of buildPatientMealSelectionInputPayload that works with flat arrays
 * This is used by the common provider which maintains flat arrays instead of grouped structures
 */
var buildPatientMealSelectionInputPayloadFromFlat = function (entrees, snacksAndSides, foodProgramUserId, dietPlanDeliveryMenuId) {
    var menuOptionSelectionToMealSelectionInput = function (menuOptionSelection) {
        var payload = {
            menuOptionId: menuOptionSelection.menuOptionId,
            quantity: menuOptionSelection.quantity,
        };
        if (menuOptionSelection.mealOptionType === graphql_api_admin_1.MealOptionType.MealKit) {
            payload.mealKitVariantId =
                menuOptionSelection.mealkitVariantId || undefined;
            payload.mealOptionType = menuOptionSelection.mealOptionType;
        }
        return payload;
    };
    var allSelections = __spreadArray(__spreadArray([], entrees, true), snacksAndSides, true).map(menuOptionSelectionToMealSelectionInput)
        .filter(function (selection) { return selection.quantity > 0; });
    return {
        foodProgramUserId: foodProgramUserId,
        deliveryMenuId: dietPlanDeliveryMenuId,
        patientOptionSelections: allSelections,
    };
};
exports.buildPatientMealSelectionInputPayloadFromFlat = buildPatientMealSelectionInputPayloadFromFlat;
var convertMenuOptionSelectionToMenuOptionSelectionAvailable = function (menuOptionSelection) {
    return {
        dishId: menuOptionSelection.dishId,
        referenceId: menuOptionSelection.referenceId,
        mealOptionType: menuOptionSelection.mealOptionType || graphql_api_admin_1.MealOptionType.Dish,
        menuOptionId: menuOptionSelection.menuOptionId,
        name: menuOptionSelection.name,
        photoUrl: menuOptionSelection.photoUrl,
        quantity: menuOptionSelection.quantity,
        type: menuOptionSelection.type,
        tagsByCategory: menuOptionSelection.tagsByCategory,
        mealkitVariants: [],
    };
};
/**
 * Aggregates meal kit variants from a flat array of menu option selections
 */
var aggregateMealKitVariants = function (menuOptionSelections, systemType) {
    var menuOptionSelectionAvailable = [];
    menuOptionSelections.forEach(function (menuOptionSelection) {
        var _a;
        if (menuOptionSelection.mealOptionType !== graphql_api_admin_1.MealOptionType.MealKit) {
            menuOptionSelectionAvailable.push(convertMenuOptionSelectionToMenuOptionSelectionAvailable(menuOptionSelection));
            return;
        }
        // Check if the menuOptionSelection is already in the menuOptionSelectionAvailable
        var existingMenuOptionSelectionAvailable = menuOptionSelectionAvailable.find(function (menuOptionSelectionAvailableItem) {
            return menuOptionSelectionAvailableItem.menuOptionId ===
                menuOptionSelection.menuOptionId;
        });
        if (existingMenuOptionSelectionAvailable) {
            (_a = existingMenuOptionSelectionAvailable.mealkitVariants) === null || _a === void 0 ? void 0 : _a.push({
                id: menuOptionSelection.mealkitVariantId || '',
                ingredientName: menuOptionSelection.mealkitVariantIngredientName || '',
                quantity: menuOptionSelection.quantity,
            });
            existingMenuOptionSelectionAvailable.quantity +=
                menuOptionSelection.quantity;
        }
        else {
            menuOptionSelectionAvailable.push({
                dishId: menuOptionSelection.dishId,
                referenceId: menuOptionSelection.referenceId,
                mealOptionType: menuOptionSelection.mealOptionType,
                menuOptionId: menuOptionSelection.menuOptionId,
                name: menuOptionSelection.name,
                photoUrl: menuOptionSelection.photoUrl,
                quantity: menuOptionSelection.quantity,
                type: menuOptionSelection.type,
                tagsByCategory: menuOptionSelection.tagsByCategory,
                mealkitVariants: [
                    {
                        id: menuOptionSelection.mealkitVariantId || '',
                        ingredientName: menuOptionSelection.mealkitVariantIngredientName || '',
                        quantity: menuOptionSelection.quantity,
                    },
                ],
            });
        }
    });
    // Inject meal type as synthetic tags into the items
    var mealTypeTagLabels = (0, exports.getMealTypeTagLabelByValue)(systemType);
    var mealPlanOptionCategoryLabel = (0, exports.getMealPlanOptionCategoryLabel)(systemType);
    var itemsWithMealTypeTags = menuOptionSelectionAvailable.map(function (item) {
        if (item.type === graphql_api_admin_1.DishType.Snack) {
            return item;
        }
        var mealTypeTagLabel = mealTypeTagLabels[item.mealOptionType];
        var translatedTagName = (0, utils_1.resolveI18n)(mealTypeTagLabel);
        var translatedCategoryName = (0, utils_1.resolveI18n)(mealPlanOptionCategoryLabel);
        var mealTypeTag = {
            id: item.mealOptionType === graphql_api_admin_1.MealOptionType.MealKit ? 'mealkit' : 'prepared',
            name: translatedTagName,
        };
        var mealTypeCategory = {
            categoryId: 'meal-plan-option',
            categoryName: translatedCategoryName,
            tags: [mealTypeTag],
            hidden: true,
        };
        return __assign(__assign({}, item), { tagsByCategory: __spreadArray(__spreadArray([], (item.tagsByCategory || []), true), [mealTypeCategory], false) });
    });
    return itemsWithMealTypeTags;
};
exports.aggregateMealKitVariants = aggregateMealKitVariants;
